import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ConceptSection from './components/ConceptSection';
import StoreInfo from './components/StoreInfo';
import MenuContent from '@/pages/menu/components/MenuContent';
import KodawariContent from '@/pages/about/components/KodawariContent';
import AccessContent from '@/pages/access/components/AccessContent';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="bg-auto bg-repeat" style={{ backgroundImage: 'url(https://storage.helloreaddy.io/project_files/fbab44cd-04c6-492b-a442-ed8f359ae362/72c694f9-1409-463b-96d1-bc011dfd125d_compressed_14.webp)' }}>
        <HeroSection />
        <ConceptSection />
        <MenuContent topPadding={false} />
        <KodawariContent />
        <AccessContent />
        <StoreInfo />
      </main>
      <Footer />
    </div>
  );
}